
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#EA983F","stroke-width":"1.25","d":"M1.391.625h35.515v28.75H1.391z"}}),_c('path',{attrs:{"fill":"#EA983F","d":"M5.092 5h12.976v13.75H5.092zM20.229 5h12.976v13.75H20.229z"}}),_c('path',{attrs:{"stroke":"#EA983F","stroke-width":"1.875","d":"M5.092 21.563h12.976M20.229 21.563h12.975M20.229 24.063h12.975M5.092 24.063h12.976"}})])
          )
        }
      }
    